import React from "react";
import "./Sponsors.scss"

class Sponsors extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
        };
        
    }

	render() {
		return (
			<div className="sponsorsSection section" ref={this.props.refs}>
                <h1 className="center">Sponsors</h1>
                    <div className="sponsorsList">
                        <img className="sponsorsLogo" src={require("assets/img/Anker-Logo.png")} />
                        <img className="sponsorsLogo" src={require("assets/img/NXP-Logo.svg.png")} />
                        <img className="sponsorsLogo" src={require("assets/img/Agriculture-and-Agri-Food-Canada.png")} />
                        <img className="sponsorsLogo" src={require("assets/img/mcmaster.png")} />
                    </div>
                    <div className="discriptionWrapper">
                        <p className="sponsorsDiscription center">
                            This project would not have a success without our wonderful sponsors. Thank you to The McMaster Museum of Art graciously granted the opportunity to deploy our system in their facilities, Anker & NXP generously provided us with hardware samples for our project and Agriculture and Agri-Food Canada for collaborated with us on the validation and verification of our sensed variables.
                        </p>
                        {/* <img className="sponsorsImage frame" src={require("assets/img/DSC_0052.jpg")} /> */}
                    </div>

			</div>
		);
	}
}
export default Sponsors;
